import { GetThumbPlaceholdersCountParams } from '../interfaces/productGallery.interfaces';

export const getThumbPlaceholdersCount = ({
  thumbsCount,
  maxThumbs,
}: GetThumbPlaceholdersCountParams): number => Math.max(0, maxThumbs - thumbsCount);
